import React from 'react';

const VoiceControls = ({
  isListening,
  isSpeaking,
  isLoading,
  onStartListening,
  onStopSpeaking
}) => {
  const isVoiceSupported = 'webkitSpeechRecognition' in window || 'SpeechRecognition' in window;
  const isSpeechSupported = 'speechSynthesis' in window;

  return (
    <div style={{ display: 'flex', gap: '0.5rem' }}>
      {isVoiceSupported && (
        <button
          onClick={onStartListening}
          disabled={isListening || isLoading}
          style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            cursor: isListening || isLoading ? 'not-allowed' : 'pointer',
            transition: 'all 0.3s',
            background: isListening ? '#ef4444' : '#a855f7',
            color: 'white',
            animation: isListening ? 'pulse 2s infinite' : 'none'
          }}
          title={isListening ? 'Escuchando...' : 'Hablar'}
        >
          {isListening ? '⏹️' : '🎤'}
        </button>
      )}

      {isSpeechSupported && (
        <button
          onClick={isSpeaking ? onStopSpeaking : undefined}
          style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            background: isSpeaking ? '#ef4444' : '#3b82f6',
            color: 'white',
            animation: isSpeaking ? 'pulse 2s infinite' : 'none'
          }}
          title={isSpeaking ? 'Detener audio' : 'Audio activado'}
        >
          {isSpeaking ? '🔇' : '🔊'}
        </button>
      )}
    </div>
  );
};

export default VoiceControls;